import { createContext, useContext, ReactNode, useState } from "react";
import { Alert, Snackbar, SnackbarCloseReason } from "@mui/material";

type SnackbarContextValue = {
  showSnackbar: (message: string, status?: "success" | "error") => void;
};

export const SnackbarContext = createContext<SnackbarContextValue>({
  showSnackbar: () => {},
});

export function SnackbarProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState<"success" | "error">("error");

  function showSnackbar(
    message: string,
    status: "success" | "error" = "error"
  ) {
    setMessage(message);
    setSeverity(status);
    setOpen(true);
  }

  function handleClose(
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  }

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
        <Alert severity={severity} variant="filled" sx={{ minWidth: "25%" }}>
          {message || "Error"}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
}

export function useSnackbar() {
  const { showSnackbar } = useContext(SnackbarContext);
  return { showSnackbar };
}
